module.exports = __webpack_public_path__ + "static/media/mobile_second_img.de362370.png";